import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_AUTH } from '../routes/paths';

// ----------------------------------------------------------------------

RegisterGuard.propTypes = {
  children: PropTypes.node
};

export default function RegisterGuard({ children }) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={PATH_AUTH.verifyEmail} />;
  }

  return <>{children}</>;
}
